import {
  IGetCaseListItem,
  IGetCaseListRequest,
  IGetCaseListResponse,
} from 'src/state/slice/models/CaseLifecycleTypes';

export interface GetCaseListApiState {
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  request: IGetCaseListRequest;
  error?: any;
  aggregatedResponse?: IGetCaseListResponse;
}

export enum ApiStateActionType {
  SUCCESS = 'success',
  FAILURE = 'failure',
  RE_FETCH = 're-fetch',
  UNKNOWN = 'unknown',
}

export interface ApiStateActions {
  type: ApiStateActionType;
  data: any;
}

export const apiStateReducerFunction = (
  state: GetCaseListApiState,
  action: ApiStateActions,
): GetCaseListApiState => {
  switch (action.type) {
    case ApiStateActionType.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isFetching: false,
        isError: false,
        error: undefined,
        aggregatedResponse: action.data,
      };
    }
    case ApiStateActionType.FAILURE: {
      return {
        ...state,
        isLoading: false,
        isFetching: false,
        isError: true,
        error: action.data,
        aggregatedResponse: undefined,
      };
    }
    case ApiStateActionType.RE_FETCH: {
      return {
        ...state,
        request: action.data,
        isLoading: false,
        isFetching: true,
        isError: false,
        error: undefined,
        aggregatedResponse: undefined,
      };
    }
    default:
      return state;
  }
};

export function handleApiSuccess(
  dispatch: Function,
  data: Array<IGetCaseListItem>,
) {
  dispatch({
    type: ApiStateActionType.SUCCESS,
    data: { caseDetails: data, nextToken: '' },
  });
}

export function handleApiFailure(dispatch: Function, data: any) {
  dispatch({
    type: ApiStateActionType.FAILURE,
    data: data,
  });
}

export function handleApiRefetching(
  dispatch: Function,
  data: IGetCaseListRequest,
) {
  dispatch({ type: ApiStateActionType.RE_FETCH, data: data });
}
